import InputSearch from "ui/components/Input/InputSearch";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
}

function HeaderTable({ onSearch, value }: HeaderTableProps) {
  return (
    <div style={{ display: "flex", flexDirection: "row", minWidth: 380 }}>
      <div style={{ flex: 1 }}>
        <InputSearch defaultValue={value} onSearch={(v) => onSearch(v)} />
      </div>
    </div>
  );
}

export default HeaderTable;
